
<c-inspection-data
    :has-data    = "true"
    status       = "X"
    :show-header = "false"
    :height      = "height"
    :show-border = "true"
    title       = "Kontakte"
>
    <template v-slot:body>
        <div class="v-flex mt-3 mr-2 pl-5" :key = "refresh">
            <div class="w-50 pr-2">
                <p-inspection-contact-iterator
                    :contacts = "inspection.unit.contact.onSite"
                    @favorite = "onFavorite"
                />
            </div>
            <div class="w-50 pl-2">
                <p-inspection-contact-iterator
                    :contacts = "inspection.unit.contact.customer"
                    @favorite = "onFavorite"
                />
            </div>
        </div>
    </template>
</c-inspection-data>
